'use client';

import { usePathname } from 'next/navigation';

import { DeviceSwitcher } from '../components/device-switcher.component';
import { PublicDesktopContent } from './desktop/public-desktop-content.component';
import { PublicMobileContent } from './mobile/public-mobile-content.component';

export const PublicContentContainer = () => {
  const pathname = usePathname() ?? '';

  return (
    <DeviceSwitcher
      desktop={<PublicDesktopContent pathname={pathname} />}
      mobile={<PublicMobileContent pathname={pathname} />}
    />
  );
};
